export default class Urls {
  static baseUrl = process.env.REACT_APP_TGPL_URL;
  static lambdaUrl = process.env.REACT_APP_LAMBDA_URL;
  static parseUrl = `${this.baseUrl}/parse`;
  static MASTERKEY = process.env.REACT_APP_MASTER_KEY;
  static APPLICATIONID = process.env.REACT_APP_APPLICATION_ID;
}
